module.exports = __webpack_public_path__ + "media/announce.b9fc5d04.mp4";